export default "__VITE_PUBLIC_ASSET__7e0de872__"